import { render } from "./AwardSummary.vue?vue&type=template&id=2b70a46e&scoped=true"
import script from "./AwardSummary.vue?vue&type=script&lang=js"
export * from "./AwardSummary.vue?vue&type=script&lang=js"

import "./AwardSummary.vue?vue&type=style&index=0&id=2b70a46e&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b70a46e"]])

export default __exports__